import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';

import ExitTestButton from '../../ExitTestButton';

import styles from '../../testOverview.scss';

/**
 * The message contains HTML because the rejection message contains bold
 * formatting and multiple paragraphs.
 */
class PureManualIdVerificationRejected extends React.PureComponent {
    static propTypes = {
        message: PropTypes.string.isRequired,
    };

    render() {
        const { message } = this.props;

        /**
         * Add a div inside infoMultilineContent for setting innerHTML.
         * This div is useless for the browser or for styling.
         */
        return (
            <div className={styles.infoMultiline}>
                <i
                    className={`${styles.infoMultilineIcon} fa fa-info-circle`}
                    aria-hidden
                />
                <div className={styles.infoMultilineContent}>
                    <div dangerouslySetInnerHTML={{ __html: message }} />
                    <ExitTestButton showButtonForNonLockdown />
                </div>
            </div>
        );
    }
}

function computeProps() {
    return {
        message: t('manualIdVerification.rejected'),
    };
}

function ManualIdVerificationRejected(props) {
    const newProps = computeProps();

    return <PureManualIdVerificationRejected {...props} {...newProps} />;
}

export default ManualIdVerificationRejected;
export { PureManualIdVerificationRejected };
